module.exports = __webpack_public_path__ + "img/taza_mock.1cee8664.png";